import type { LobbyPlayer } from "@rosette/ts/src/business/lobby/LobbyPlayer.js";
import type { APIPublicGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import { defaultGamePreferences } from "@rosette/ts/src/business/api/api_schema.js";
import { DisplayName } from "./DisplayName.js";
import { Role } from "@rosette/ts/src/business/role/Role.js";
import { HumanLobbyPlayer } from "@rosette/ts/src/business/lobby/HumanLobbyPlayer.js";


interface LobbyPlayerDisplayNameProps {
    player: LobbyPlayer | null;
}


export function LobbyPlayerDisplayName({ player }: LobbyPlayerDisplayNameProps) {
    let name = "Anonymous";
    let preferences: APIPublicGamePreferences = defaultGamePreferences;
    let roles: Role[] = [];

    if (player) {
        name = player.getShortName();
        preferences = player.getPreferences() ?? defaultGamePreferences;
        if (player instanceof HumanLobbyPlayer) {
            roles = Role.list(player.getUserOrNull());
        }
    }

    return (
        <DisplayName
            name={name}
            preferences={preferences}
            roles={roles} />
    );
}
